import {put, select} from "redux-saga/effects";
import {IApplicationState} from "../../index";
import {ILevelMap, ILevelMapAggregatedTile, ILevelMapTileProgress, TileType} from "../../game/types";
import {setLevelProgress} from "../../game/actions";

export function findExitTile(tiles: ILevelMapAggregatedTile[][]) {
    for (let row of tiles) {
        for (let tile of row) {
            if (tile.tileType === TileType.Exit) {
                return tile;
            }
        }
    }
}

export default function* () {
    const {map, progress}: {map: ILevelMap, progress: Record<number, ILevelMapTileProgress>} = yield select(({ game }: IApplicationState) => ({
        map: game.levelMaps[game.levelInProgress],
        progress: game.levelMapTileProgress
    }));

    if (!map)
        return false;

    let exitTile = findExitTile(map.tiles);

    if (!exitTile || exitTile.isRevealed || (progress[exitTile.id] && progress[exitTile.id].isRevealed))
        return false;

    yield put(setLevelProgress({
        isExitFound: false,
        levelProgress: {
            [exitTile.id]: {
                id: exitTile.id,
                isRevealed: true
            }
        }
    }));

    return true;
}